import { SearchUserField } from './SearchUserField'
import { withSearchUserField } from './withSearchUserField'

const ConnectedSearchUserField = withSearchUserField(SearchUserField)

export { ConnectedSearchUserField as SearchUserField }
